import React, { useEffect, useState } from 'react'
import { useErrorHandling } from 'context/errorHandling'
import { fetchFerryServicesOfContractor } from 'services'
import { ControlledSelectField } from 'components/Shared/ControlledSelectField'
import { useTranslation } from 'react-i18next'

export function FerryServiceSelectField ({ name, label, contractorId, ...rest }) {
  const [ferryServices, setFerryServices] = useState([])
  const { handleError } = useErrorHandling()
  const { t } = useTranslation()

  useEffect(() => {
    if (contractorId) {
      fetchFerryServicesOfContractor(contractorId)
        .then(setFerryServices)
        .catch(handleError)
    } else {
      setFerryServices([])
    }
  }, [contractorId, handleError])

  return (
    <ControlledSelectField
      fieldName={name}
      label={t(label)}
      options={ferryServices}
      getOptionValue={f => f.id}
      getOptionLabel={formatFerryServiceLabel}
      {...rest}
    />
  )
}

const formatFerryServiceLabel = service => `${service.startLocation.text} - ${service.endLocation.text}`
